import React from 'react';
import { VehicleIssueTypeEnum } from '@/utils/enum';
import { VehicleIssueType } from '@/utils/types';
import './index.scss';

interface VehicleIssueTypeBadgeProps {
  issueType: VehicleIssueType; // 车辆当前的状态（维修中/停用中/待验收）
  /** 与父组件的顶部的距离 */
  top?: string;
  /** 与父组件的右侧的距离 */
  right?: string;
  /** 点的大小 */
  size?: string;
  className?: string;
}

const VehicleWarnTypeToBadgeMap: Record<VehicleIssueTypeEnum, any> = {
  [VehicleIssueTypeEnum.REPAIR]: require('@/assets/images/historyOrders/issue-type-repair.png'),
  [VehicleIssueTypeEnum.STOP]: require('@/assets/images/historyOrders/issue-type-stop.png'),
  [VehicleIssueTypeEnum.TO_DO_CHECK]: require('@/assets/images/historyOrders/issue-type-to-check.png')
};

function VehicleIssueTypeBadge(props: VehicleIssueTypeBadgeProps) {
  const {
    issueType,
    top = '35px',
    right = '20px',
    size = '60px',
    className = ''
  } = props;

  const currentIssueTypeBadgeSrc =
    (issueType && VehicleWarnTypeToBadgeMap[issueType]) || null;

  return (
    <>
      {currentIssueTypeBadgeSrc && (
        <div
          className={`issue-type-badge ${className}`}
          style={{ top, right, width: size, height: size }}
        >
          <img
            src={currentIssueTypeBadgeSrc}
            className="issue-type-badge-img"
          />
        </div>
      )}
    </>
  );
}
export default VehicleIssueTypeBadge;
